import { render, staticRenderFns } from "./SolutionsCardWithButton.vue?vue&type=template&id=c4d6d956&scoped=true"
import script from "./SolutionsCardWithButton.vue?vue&type=script&lang=js"
export * from "./SolutionsCardWithButton.vue?vue&type=script&lang=js"
import style0 from "./SolutionsCardWithButton.vue?vue&type=style&index=0&id=c4d6d956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d6d956",
  null
  
)

export default component.exports